import { apiRequest } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function getInstructorById(instructorId) {
  return apiRequest(`/api/instructors/${instructorId}`, {
    method: 'GET',
    headers: getAuthHeaders(),
    allowNotFound: true,
  });
}
